import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import cn from "classnames";

import { Stack, Shelf } from "capitalrx-components-2.0/lib/layout";

import { PanelContainer, Heading, Body, Button } from "@/basic/components";
import { ALLOW_FORMULARY_LIST } from "@/basic/constants/allowClientList";
import styles from "./styles.module.scss";

export interface FormularyButtonContainerProps {
  className?: string;
}

export interface FormularyParams {
  formulary?: string;
}

export const FormularyButtonContainer = (props: FormularyButtonContainerProps) => {
  const { t: translate } = useTranslation();
  const { className } = props;
  const { formulary }: FormularyParams = useParams();
  const FormularyButtonContainerClass = cn(styles["StepsContainer"], className);

  const handleFormularyButtonClick = () => {
    if (Object.prototype.hasOwnProperty.call(ALLOW_FORMULARY_LIST, formulary)) {
      const formularyUrl = ALLOW_FORMULARY_LIST[formulary];
      window.open(formularyUrl, "_blank", "noreferrer");
    }
  };

  return (
    <PanelContainer {...props} className={FormularyButtonContainerClass}>
      <Stack spacing="large">
        <Stack spacing="mini">
          <Heading>{translate("FORMULARY_BUTTON_CONTAINER.findDrugsCovered")}</Heading>
          <Body>{translate("FORMULARY_BUTTON_CONTAINER.wePreparedFormulary")}</Body>
        </Stack>

        <Stack spacing="mini">
          <Shelf>
            <Button icon="link-out" onClick={handleFormularyButtonClick}>
              {translate("FORMULARY_BUTTON_CONTAINER.viewFormulary")}
            </Button>
            <Shelf.Spacer />
          </Shelf>
          <Body size="mini">{translate("FORMULARY_BUTTON_CONTAINER.someDrugsMayNotBeCovered")}</Body>
        </Stack>
      </Stack>
    </PanelContainer>
  );
};
